<template>
    <div class= "despreEO">
        <div class = "chenarEO">
          <h1 v-html="$t(title)" class = "titluEO"></h1>
          <p v-html="$t(content)" class = "textEO"></p>
        </div>
    </div> 
</template>

<script>
  export default {
    props: [
      'title',
      'content'
    ]
  }
 </script>

<style lang="scss" scoped>
  .despreEO {
    min-height: 10vh;
    width: 100%;
    margin-top: 0px;
    margin-bottom: 0px;
    padding-top: 2%;
    padding-bottom: 2%;
  }
  .chenarEO {
    margin-left: 10%;
    margin-right: 10%;
    background-color: $secondary-color;
    min-height: 5vh;
    width: 80%;
    border-style: solid;
    border-radius:29px;
    -moz-border-radius:29px;
    -webkit-border-radius:29px;
    overflow: hidden;
  }

  @media screen and (max-width: 600px) {
      .chenarEO {
        width: 94%;
        margin-left: 3%;
        margin-right: 3%;
      }
  }

  .textEO {
    padding-bottom: 2%;
    padding-top: 2%;
    padding-right: 2%;
    padding-left: 2%;
    color: white;
  }
  .titluEO {
    background-color: $primary-color;
    padding-bottom: 2%;
    padding-top: 2%;
    padding-right: 2%;
    padding-left: 2%;
    color: white;
    font-size: 36px;
  }
</style>  